module.exports = __webpack_public_path__ + "static/lights34-dcc1923e75844737c7a3da0347d26112.jpg";